<template>
  <mds-empty-state
    class="save-failure__response-message"
    :title="translate('scheduler.modal.save.failure.title')"
    :message="translate('scheduler.modal.save.failure.message')"
  >
    <template #mds-empty-state-icon>
      <mds-inline-message
        class="save-failure__check-mark"
        variation="error"
        icon-only
      />
    </template>
    <template #mds-empty-state-actions>
      <div class="save-failure__actions">
        <mds-button variation="secondary" @click="$emit('save', false)">
          {{ translate('scheduler.modal.save.failure.tryagain.button') }}
        </mds-button>
        <mds-button
          class="save-failure__close-button"
          variation="flat"
          @click="onClick()"
        >
          {{ translate('scheduler.modal.save.failure.cancel.button') }}
        </mds-button>
      </div>
    </template>
  </mds-empty-state>
</template>

<script>
import { MdsButton } from '@mds/button'
import MdsEmptyState from '@mds/empty-state'
import MdsInlineMessage from '@mds/inline-message'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'
import { CANCEL_MESSAGE } from '@/components/schedulerModal/config/constants'

export default {
  name: 'FailureResponseMessage',
  components: {
    MdsButton,
    MdsEmptyState,
    MdsInlineMessage,
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  methods: {
    onClick() {
      this.$emit('close')
      window.chrome?.webview?.postMessage(CANCEL_MESSAGE)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.save-failure {
  &__response-message {
    &::v-deep > [class^='mds-empty-state__icon'] {
      margin-bottom: 0;
    }
  }
  &__check-mark {
    &::v-deep > [class^='mds-icon'] {
      width: $mds-space-7-x;
    }
  }
  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__close-button {
    margin-top: $mds-space-1-x;
  }
}
</style>
